/* eslint-disable @typescript-eslint/no-explicit-any */
import { Theme } from "@tvg/fuse/theme";
import DevButtons from "client/components/ComplexHeader/dev/DevButtons";
import React from "react";
import { BrandValue } from "../../../common/types/common";
import ComplexHeaderComponent from "../../components/ComplexHeader/ComplexHeader";
import { MainStoreProvider } from "../../state/Main";

export interface ComplexHeaderContainerProps {
  brand: BrandValue;
  environment: string;
  creditCustomer: boolean;
  navigation?: any;
  preventSSRSubMenu?: boolean;
  isMyOffersEnabled?: boolean;
}

const ComplexHeaderContainer: React.FC<ComplexHeaderContainerProps> = ({
  brand,
  environment,
  creditCustomer,
  navigation,
  preventSSRSubMenu,
  isMyOffersEnabled,
}: ComplexHeaderContainerProps) => {
  return (
    <MainStoreProvider
      isCreditCustomer={creditCustomer}
      brand={brand}
      navigation={navigation}
      preventSSRSubMenu={preventSSRSubMenu}
      isMyOffersEnabled={isMyOffersEnabled}
    >
      <Theme brand={brand} />
      <ComplexHeaderComponent brand={brand} environment={environment} />
      <DevButtons />
    </MainStoreProvider>
  );
};

ComplexHeaderContainer.displayName = "ComplexHeaderContainer";

export default ComplexHeaderContainer;
